import sanitizeHtml from "sanitize-html";

export default {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat([
    "img",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "small",
    "strong",
    "span",
    "ins",
    "u",
    "br",
    "var",
    "code",
    "cite",
    "del",
    "fieldset",
    "legend",
    "i",
    "font",
    "strike"
  ]),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    div: ["class", "style"],
    img: [
      ...sanitizeHtml.defaults.allowedAttributes.img,
      "height",
      "width",
      "src",
      "style"
    ],
    p: ["class", "style"],
    small: ["class"],
    span: ["class", "style"],
    table: [
      "border",
      "cellpadding",
      "cellspacing",
      "style",
      "summary",
      "class"
    ],
    td: ["style", "class"],
    h1: ["style"],
    h2: ["style"],
    h3: ["style"],
    h4: ["style"],
    h5: ["style", "class"],
    h6: ["style"],
    fieldset: ["class", "style"],
    legend: ["class"],
    i: ["class", "id"],
    font: ["color"],
    strike: ["class", "style"],
    col: ["style"]
  },
  allowedSchemes: [...sanitizeHtml.defaults.allowedSchemes, "data"],
  allowedStyles: {
    "*": {
      background: [/^((?![<>]).)*$/],
      "background-color": [
        /^#(0x)?[0-9a-f]+$/i,
        /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/
      ],
      border: [/^((?![<>]).)*$/],
      color: [
        /^#(0x)?[0-9a-f]+$/i,
        /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/
      ],
      "font-size": [/^\d+(?:px|em|%)$/],
      "font-style": [/^italic$/, /^normal$/, /^oblique$/],
      "font-weight": [
        /^normal$/,
        /^bold$/,
        /^lighter$/,
        /^bolder$/,
        /^inherit$/,
        /^initial$/,
        /^unset$/,
        /^\d+$/
      ],
      padding: [/^((?![<>]).)*$/],
      "text-align": [/^left$/, /^right$/, /^center$/],
      width: [/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)(?:px|em|%)$/],
      "border-bottom": [/^.*$/],
      "border-left": [/^.*$/],
      "border-right": [/^.*$/],
      "border-top": [/^.*$/],
      "padding-bottom": [/^.*$/],
      "padding-left": [/^.*$/],
      "padding-right": [/^.*$/],
      "padding-top": [/^.*$/],
      "margin-bottom": [/^.*$/],
      "margin-left": [/^.*$/],
      "margin-right": [/^.*$/],
      "margin-top": [/^.*$/],
      display: [/^.*$/],
      "max-width": [
        /^\d+(?:px|em|%)$/,
        /^min\(\s*\d+(?:px|em|%)\s*,\s*\d+(?:px|em|%)\s*\)$/
      ],
      float: [/^right$/, /^left$/],
      "white-space": [/^pre-wrap$/, /^nowrap$/],
      "table-layout": [/^.*$/],
    }
  }
};

// Match any number with px, em, or %: /^\d+(?:px|em|%)$/
// Match HEX and RGB: /^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/
// Match anything that does not contain angle brackets: /^((?![<>]).)*$/
